import { memo, useCallback } from "react";
import { Pagination as PaginationAntd } from "antd";
import { useEditSettingPaginations } from "queries";

import "./Pagination.css";

const Pagination = ({
  current = 1,
  pageSize = 15,
  total = 0,
  lastPage = 1,
  onChange = () => {},
  onShowSizeChange = () => {},
  showSizeChanger = false,
  minPageSize = 15,
  keyPerPage = "",
  hideOnSinglePage = false,
  pageSizeOptions = [15, 25, 50, 100],
  ...props
}) => {
  const editPagination = useEditSettingPaginations();

  const onChangePageSize = useCallback(
    (current, size) => {
      if (keyPerPage) {
        editPagination.mutate({
          [keyPerPage]: size,
        });
      }
      if (typeof onShowSizeChange === "function") {
        onShowSizeChange(current, size);
      }
    },
    [onShowSizeChange, editPagination, keyPerPage]
  );

  return (
    <PaginationAntd
      current={current}
      pageSize={pageSize}
      total={total}
      showSizeChanger={showSizeChanger}
      onChange={onChange}
      pageSizeOptions={pageSizeOptions || []}
      onShowSizeChange={onChangePageSize}
      hideOnSinglePage={
        hideOnSinglePage
          ? hideOnSinglePage
          : total <= minPageSize
          ? true
          : false
      }
      className={lastPage === 1 ? "pagination-only-size" : ""}
      {...props}
    />
  );
};

export default memo(Pagination);
